import { useState } from 'react';
import Assignment from "./Assignment";
import Quiz from './QuizExcersise';
import DemoExcersise from './DemoExcersise';
import LapExcersise from './LapExcersise';

export default function ParentExercise() {
  const [activeTab, setActiveTab] = useState('Assignment');

  const tabs = ['Assignment', 'Quiz', 'Demo', 'Lab'];

  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Tab Navigation */}
      <div className="flex justify-start items-start border-b border-gray-200 gap-2">
        {tabs.map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`px-8 py-3 transition-colors relative ${
              activeTab === tab ? 'text-white' : 'text-stone-900 bg-white'
            }`}
            style={activeTab === tab ? { backgroundColor: '#4AACC5' } : {}}
          >
            <div
              className={`text-base font-['Roboto'] ${
                activeTab === tab ? 'font-medium' : 'font-normal'
              }`}
            >
              {tab}
            </div>
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div>
        {activeTab === 'Assignment' && <Assignment />}
        
        {activeTab === 'Quiz' && <Quiz />}
        
        {activeTab === 'Demo' && <DemoExcersise />}
        
        {activeTab === 'Lab' && <LapExcersise />}
      </div>
    </div>
  );
}